import React from 'react'
import { connect } from 'react-redux'

// CONSTANTS
import { tenantColors } from '../_constants/colors'

// Components
import Dropzone from '../_components/Dropzone'
import { UploadInvoices } from '../_components/UploadInvoices'

// Actions
import { userActions, dealActions } from '../_actions'
import { dealService, documentsService } from '../_services'

class UploadInvoicesWrapper extends React.Component {
  state = {
    files: [],
    invoices: [],
  }

  handleInvoiceUpload = (acceptedFiles, rejectedFiles) => {
    let filesCopy = [...this.state.files, ...acceptedFiles]
    this.setState(
      {
        files: filesCopy,
      },
      () => {
        this.handleUploadInvoices()
      }
    )
  }

  handleUploadInvoices = () => {
    const { deal, createDeal, business } = this.props
    if (!deal || !deal.deal_status) {
      createDeal(business.id).then((_resp) => {
        this.uploadInvoices()
      })
    } else {
      this.uploadInvoices()
    }
  }

  uploadInvoices = () => {
    const { files } = this.state
    files.forEach((file) => {
      // Don't allow files to be added to invoices twice
      if (!file.hasBeenAddedToInvoice) {
        this.uploadAndCreateInvoice(file)
      }
    })
    // Make sure each file is flagged
    let currentFiles = [...files]
    currentFiles.forEach((file) => {
      file.hasBeenAddedToInvoice = true
    })
    this.setState({
      files: currentFiles,
    })
  }

  uploadAndCreateInvoice = (file) => {
    const { business, deal, user } = this.props
    dealService.createInvoice(business.id, deal.id).then((resp) => {
      let invoice = resp
      invoice.document_name = file.name
      let invoicesCopy = [...this.state.invoices, invoice]
      this.setState(
        {
          invoices: invoicesCopy,
        },
        () => {
          documentsService.updateDocument(invoice.document_id, `document_name`, invoice.document_name)
          documentsService.updateDocument(invoice.document_id, `data_source`, invoice.data_source)
          documentsService.updateInvoice(invoice.id, `data_source`, invoice.data_source)

          documentsService.uploadInvoice(file, user.id, false, deal.id, invoice.document_id)
        }
      )
    })
  }

  removeInvoice = (i) => {
    let invoicesCopy = [...this.state.invoices]
    invoicesCopy.splice(i, 1)
    this.setState({
      invoices: invoicesCopy,
    })
  }

  render() {
    const { tenant, accountingPlatform, deal, onSubmit = () => {} } = this.props
    const isConnectedToAccountingPlatform = accountingPlatform && accountingPlatform !== `none`

    // Can't upload documents (invoices) if there's no deal
    if (!deal || !deal.id) {
      return null
    }

    return (
      <div>
        <Dropzone
          bordercolor={tenantColors[tenant].primary}
          handleUpload={this.handleInvoiceUpload}
          text="Upload invoices, purchase orders, and other receivables"
        />
        {this.state.invoices.length > 0 && (
          <UploadInvoices invoices={this.state.invoices} onSubmit={onSubmit} removeInvoice={this.removeInvoice} />
        )}
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setFlowStep: (userId, value) => {
      dispatch(userActions.updateUser('flow_step', value, userId))
    },
    createDeal: (businessId) => {
      dispatch(dealActions.createDeal(businessId))
    },
  }
}

function mapStateToProps(state) {
  const { user, business, env, accounting, deal } = state
  return {
    user,
    business,
    tenant: env.tenant,
    accountingPlatform: accounting.platform,
    deal: deal.deal,
  }
}

const connectedUploadInvoicesWrapper = connect(mapStateToProps, mapDispatchToProps)(UploadInvoicesWrapper)
export { connectedUploadInvoicesWrapper as UploadInvoicesWrapper }
